import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';
const names = ['María', 'Laura', 'Carmen', 'Ana', 'Isabel', 'Josefina', 'Marta', 'Elena', 'Lucía', 'Rosa'];
const countries = ['Argentina', 'México', 'España', 'Colombia', 'Chile', 'Perú', 'Uruguay', 'Ecuador'];
export function SalesPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    country: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCountry = countries[Math.floor(Math.random() * countries.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setBuyer({
        name: randomName,
        country: randomCountry,
        time: `${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring
    const interval = setInterval(() => {
      showPopup();
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up max-w-sm w-[calc(100%-2rem)]" data-id="element-164">
      <div className="bg-white border-2 border-brand-green rounded-lg shadow-2xl p-3 flex items-start gap-3" data-id="element-165">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-166">
          <Check className="w-5 h-5 text-brand-green" data-id="element-167" />
        </div>
        <div data-id="element-168">
          <p className="text-sm font-medium text-gray-900" data-id="element-169">
            <span className="font-bold" data-id="element-170">{buyer.name}</span> de {buyer.country}
          </p>
          <p className="text-xs text-gray-600 mt-0.5" data-id="element-171">
            Acaba de comprar "Más de 300 Remedios Naturales"
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-172">Hace {buyer.time}</p>
        </div>
      </div>
    </div>;
}